import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { mumbaiSkyline } from "../mock";

// Reusable inner-page banner with title + breadcrumb
const PageHeader = ({ title, subtitle, crumb }) => {
  return (
    <section className="relative gradient-navy overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img src={mumbaiSkyline} alt="" className="w-full h-full object-cover" />
      </div>
      <div className="absolute -top-20 -right-16 w-80 h-80 bg-brand/20 rounded-full blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-16 md:py-20">
        <div className="flex items-center gap-2 text-sm text-slate-300 mb-4">
          <Link to="/" className="hover:text-brand transition-colors">Home</Link>
          <ChevronRight className="w-4 h-4" />
          <span className="text-brand font-medium">{crumb || title}</span>
        </div>
        <h1 className="font-display font-extrabold text-white text-4xl md:text-5xl tracking-tight text-balance">{title}</h1>
        {subtitle && <p className="mt-4 text-slate-300 max-w-2xl text-lg leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
};

export default PageHeader;
